import * as React from 'react';
import { numFormat } from 'utils/numFormat';
import cx from 'classnames';
import styles from './RatingCountUnit.css';
import StringWidget from 'components/StringWidget';
const RatingCountUnit = (props) => (<div className="col">
		<div className="row">
			<div className={cx('col-12-12', styles['average-star'])}>
				<div className={styles['average']}>{props.avgRating}</div>
				<div className={styles['star']}>★</div>
			</div>
		</div>
		<div className={cx('row', styles['ratings'])}>
			<div className="col-12-12">
				<StringWidget strKey="ratingsTitleNew" attributes={{ ratingsCount: numFormat(Number(props.ratingsCount || 0)) }}/>
			</div>
		</div>
		<div className={cx('row', styles['ratings'])}>
			<div className="col-12-12">
				<StringWidget strKey="ReviewsTitle" attributes={{ reviewsCount: numFormat(Number(props.reviewsCount || 0)) }}/>
			</div>
		</div>
	</div>);
export default RatingCountUnit;
